import { Formik } from 'formik';
import { Dispatch, SetStateAction } from 'react';
import { House, LocationOn, Person } from '@mui/icons-material';
import { Button, Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import FormActionButtonLayout from '../../../components/layout/Form/FormActionButtonLayout';
import { VerticalStep, VerticalStepper } from '../../../components/Stepper';
import { isSubmitEnabled } from '../../../lib/helperFuncs';
import { renderErrors } from '../../../components/form_v2/helpers';
import { initialValuesEditErgo } from '../Registrations/types';
import LinesSkeleton from '../../../components/Skeletons/LinesSkeleton';
import Details from '../../../components/Details/Details';
import { editProjectValidation } from '../Registrations/validationSchema';

interface IPreviewForeas {
    setRenderPreview: Dispatch<SetStateAction<boolean>>;
    onSubmit: (values: any) => Promise<void>;
    data: any;
    isLoading?: boolean;
  }

const PreviewErgo = ({
  setRenderPreview,
  onSubmit,
  data,
  isLoading
}: IPreviewForeas) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const basic_info_details = [
    {
      name: 'Μοναδικός Κωδικός Έργου',
      value: data.projectUniqueCode || '-',
      refValue: 'projectUniqueCode'
    },
    {
      name: 'Aναγνωριστικό Έργου',
      value: data.projectIdentifier || '-',
      refValue: 'projectIdentifier'
    },
    {
      name: 'Τίτλος Έργου',
      value: data.projectTitle || '-',
      refValue: 'projectTitle'
    },
    {
      name: 'Τύπος Έργου',
      value: data.projectRelationWithTypeOfProject || '-',
      refValue: 'projectRelationWithTypeOfProject'
    },
    {
      name: 'Τίτλος Έργου στα Αγγλικά',
      value: data.projectEnTitle|| '-',
      refValue: 'projectEnTitle'
    },
    {
      name: 'Εναλλακτικός Τίτλος Έργου',
      value: data.projectAlternativeTitle || '-',
      refValue: 'projectAlternativeTitle'
    },
    {
      name: 'Ανήκει σε',
      value: data.projectBelongsTo || '-',
      refValue: 'projectBelongsTo'
    },
    {
      name: 'Περιγραφή Έργου',
      value: data.projectDescription || '-',
      refValue: 'projectDescription'
    },
    {
      name: 'Περιγραφή Έργου στα Αγγλικά',
      value: data.projectEnDescription || '-',
      refValue: 'projectEnDescription'
    },
    {
      name: 'Χρονολογία',
      value: data.projectYear || '-',
      refValue: 'projectYear'
    },
    {
      name: 'Μορφότυπο',
      value: data.projectFormat || '-',
      refValue: 'projectFormat'
    },
    {
      name: 'Διάρκεια',
      value: data.projectDuration || '-',
      refValue: 'projectDuration'
    },
    {
      name: 'Χρώμα',
      value: data.projectColor || '-',
      refValue: 'projectColor'
    },
    {
      name: 'Ήχος',
      value: data.projectSound || '-',
      refValue: 'projectSound'
    },
    {
      name: 'Γλώσσα',
      value: data.projectLanguage || '-',
      refValue: 'projectLanguage'
    },
    {
      name: 'Χώρα',
      value: data.projectCountry || '-',
      refValue: 'projectCountry'
    },
    {
      name: 'Μέγεθος',
      value: data.projectSize || '-',
      refValue: 'projectSize'
    },
    {
      name: 'Ύψος',
      value: data.projectHeight || '-',
      refValue: 'projectHeight'
    },
    {
      name: 'Πλάτος',
      value: data.projectWidth || '-',
      refValue: 'projectWidth'
    },
    {
      name: 'Frame Rate',
      value: data.projectFrameRate || '-',
      refValue: 'projectFrameRate'
    },
    {
      name: 'Aspect Ratio',
      value: data.projectAspectRatio || '-',
      refValue: 'projectAspectRatio'
    },
    {
      name: 'Copyright',
      value: data.projectCopyright || '-',
      refValue: 'projectCopyright'
    },
    {
      name: 'Άδεια Χρήσης',
      value: data.projectCreativeCommons || '-',
      refValue: 'projectCreativeCommons'
    },
    {
      name: 'Εκπαιδευτικό',
      value: data.projectEducational || '-',
      refValue: 'projectEducation'
    },
    {
      name: 'Εκπαιδευτικό Ίδρυμα',
      value: data.projectEduInstitution || '-',
      refValue: 'projectEduInstitution'
    },
    {
      name: 'Εκπαιδευτική Βαθμίδα',
      value: data.projectEduLevel || '-',
      refValue: 'projectEduLevel'
    },
    {
      name: 'Εκπαιδευτής',
      value: data.projectTrainer || '-',
      refValue: 'projectTrainer'
    },
    {
      name: 'Εργαστήριο',
      value: data.projectLab || '-',
      refValue: 'projectLab'
    },
    {
      name: 'Ομάδα Δημιουργίας',
      value: data.projectCreationTeam || '-',
      refValue: 'projectCreationTeam'
    },
    {
      name: 'Αριθμός Παικτών',
      value: data.projectNumberPlayers || '-',
      refValue: 'projectNumberPlayers'
    },
    {
      name: 'Κοινός Στόχος',
      value: data.projectsMutualGoal || '-',
      refValue: 'projectsMutualGoal'
    },
    {
      name: 'Διοργάνωση',
      value: data.projectOrganisation || '-',
      refValue: 'projectOrganisation'
    },
    {
      name: 'Βραβεία',
      value: data.projectAward || '-',
      refValue: 'projectAward'
    },
    {
      name: 'Παρατηρήσεις - Σχόλια Έργου',
      value: data.projectComments || '-',
      refValue: 'projectComments'
    },
    {
      name: 'Παρατηρήσεις - Σχόλια Έργου στα Αγγλικά',
      value: data.projectEnComments || '-',
      refValue: 'projectEnComments'
    }
      
  ];
  
  const contributors = [
    {
      name: 'Εμπλεκόμενοι του Έργου - Συντελεστές',
      value: data?.projectConnectorWithContributor?.map((x:any) => x.key) || '-',
      refValue: 'projectConnectorWithContributor'
    }
  ];

  const locations = [
    {
      name: 'Σχετικές Τοποθεσίες',
      value: data?.projectRelationWithLocation?.map((x:any) => x.key) || '-',
      refValue: 'projectRelationWithLocation'
    },
    {
      name: 'Άλλες Τοποθεσίες',
      value: data.projectOtherLocations || '-',
      refValue: 'projectOtherLocations'
    }

  ];

  const basicInfo = <Box
    display='flex'
    justifyContent='flex-start'
  >
    <Box width='fit-content'>
      {isLoading
        ? <LinesSkeleton lines={basic_info_details.length} />
        : <Details
          removeLines
          rows={basic_info_details}
        />
      }
    </Box>
  </Box>;

  const contributorsInfo = <Box
    display='flex'
    justifyContent='flex-start'
    gap={15} >
    <Box sx={{width: 'fit-content'}}>
      {isLoading
        ? <LinesSkeleton lines={contributors.length} />
        : <Details
          removeLines
          rows={contributors
          }
        />
      }
    </Box>
  </Box>;

  const locationsInfo = <Box
    display='flex'
    justifyContent='flex-start'
    gap={15} >
    <Box sx={{width: 'fit-content'}}>
      {isLoading
        ? <LinesSkeleton lines={locations.length} />
        : <Details
          removeLines
          rows={locations}
        />
      }
    </Box>
  </Box>;

  const steps = [
    {
      label: 'Βασικές Πληροφορίες Έργου',
      content: basicInfo,
      icon: <House />
    },
    {
      label: 'Εμπλεκόμενοι του Έργου - Συντελεστές',
      content: contributorsInfo,
      icon: <Person/>
    },
    {
      label: 'Σχετικές Τοποθεσίες',
      content: locationsInfo,
      icon: <LocationOn />
    }
  ];

  return (
    <>
      <VerticalStepper activeStep={0}>
        {steps.map(step => {
          return (
            <VerticalStep
              active={true}
              key={step.label}
              label={step.label}
              icon={step.icon}>
              {step.content}
            </VerticalStep>
          );
        })}
      </VerticalStepper>
      <Formik
        enableReinitialize
        onSubmit={() => undefined}
        initialValues={initialValuesEditErgo(data)}
        validationSchema={editProjectValidation}
        validateOnMount={true}
      >
        {formik =>
          (<>
            <Box ml={2} mt={3}>
              {renderErrors(formik.errors, [
                ...basic_info_details,
                ...contributors,
                ...locations
              ])}
            </Box>
            <FormActionButtonLayout>
              <Button 
                variant='outlined' 
                color='error'
                onClick={() => {
                  setRenderPreview(false);
                  searchParams.delete('preview');
                  searchParams.set('edit', 'true');
                  setSearchParams(searchParams);
                }}
              > 
                Επιστροφή               
              </Button>
              <Button
                disabled={isSubmitEnabled(formik.errors, true)}
                variant='contained'
                onClick={() => onSubmit(data)}
              > 
                Υποβολή
              </Button>
            </FormActionButtonLayout>
          </>)}
      </Formik>
    </>);
};

export default PreviewErgo;